var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1289 10.4336C25.6953 10.4336 27.8633 8.16016 27.8633 5.21875C27.8633 2.34766 25.6836 0.144531 23.1289 0.144531C20.5859 0.144531 18.3945 2.38281 18.4062 5.24219C18.4062 8.16016 20.5625 10.4336 23.1289 10.4336ZM9.58203 10.7031C11.8203 10.7031 13.707 8.71094 13.707 6.15625C13.707 3.64844 11.7969 1.73828 9.58203 1.73828C7.36719 1.73828 5.45703 3.68359 5.46875 6.17969C5.46875 8.71094 7.35547 10.7031 9.58203 10.7031ZM3.125 21.3438H11.9141C10.6602 19.5508 12.0078 16.0117 14.6562 13.9258C13.3672 13.0938 11.6914 12.4844 9.58203 12.4844C4.34375 12.4844 0.957031 16.3398 0.957031 19.5156C0.957031 20.6758 1.54297 21.3438 3.125 21.3438ZM15.8281 21.332H30.4297C32.3633 21.332 33.0312 20.7461 33.0312 19.668C33.0312 16.6562 29.1992 12.5078 23.1289 12.5078C17.0469 12.5078 13.2266 16.6562 13.2266 19.668C13.2266 20.7461 13.8945 21.332 15.8281 21.332Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.141e55a315d1258fa97fc422cc85f77e.svg";
export { ForwardRef as ReactComponent };